module.exports = "/images/profile-duo.svg?dc68e298ed54c60ee55b2796b7c9556d";